import styled, { css } from 'styled-components';

export const CardContainer = styled.div`
  padding: 16px;
  box-shadow: 0px 8px 20px 0px #0000000f;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  cursor: pointer;

  & + & {
    margin-top: 16px;
  }
`;

export const Title = styled.p`
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #555658;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #898b8e;

  display: block;
  margin-top: 16px;

  & + & {
    margin-top: 8px;
  }
`;

export const ClosestDate = styled.p`
  font-size: 14px;
  color: var(--blue-einstein);
  font-weight: 500;
`;

type ContainerProps = {
  isUnavailable?: boolean;
};
export const Column = styled.div<ContainerProps>`
  ${({ isUnavailable }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    opacity: ${isUnavailable ? '0.5' : '1'};
  `}
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;

export const RadioColumn = styled.div`
  margin-top: 32px;
`;
